"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatRailgunTransactions = void 0;
const formatRailgunTransactions = (txs) => {
    return txs.map(tx => {
        return {
            graphID: tx.id,
            commitments: tx.commitments,
            nullifiers: tx.nullifiers,
            boundParamsHash: tx.boundParamsHash,
            blockNumber: Number(tx.blockNumber),
        };
    });
};
exports.formatRailgunTransactions = formatRailgunTransactions;
